import { render } from "./AttachmentInteractive.vue?vue&type=template&id=19edb95a"
import script from "./AttachmentInteractive.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./AttachmentInteractive.vue?vue&type=script&charset=utf-8&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__